import Game from './game.container'
import SceneObject from './SceneObject'
import * as audioActions from './AudioContainer/audio.actions'

import * as actions from './game.actions'
import { reducer } from './game.reducer'
import * as sagas from './game.sagas'
import * as selectors from './game.selectors'

import * as statusChecker from './StatusChecker/statusChecker.sagas'
import {
  evaluateAll,
  getStatusFromConditions,
  byString,
} from './StatusChecker/statusChecker.selectors'

// Attach SceneObject to the Game namespace for backwards compatibility
Game.SceneObject = SceneObject

export {
  Game,
  SceneObject,
  audioActions,
  actions,
  reducer,
  sagas,
  selectors,
  statusChecker,
  evaluateAll,
  getStatusFromConditions,
  byString,
}
